import { Link } from '@mui/material'
import React from 'react'

const FooterLink = ({ text }) => {
  return (
    <Link 
    href="/egress-kits.html"
    variant='p'
    component='a'
    sx={{
      fontSize: '4vw',
      fontWeight: '400',
      textDecoration: 'none',
      color: '#ffffff',
      textTransform: 'uppercase',
      '@media (max-width:420px)': {
        fontSize: '8vw'      
        
      },
      "&:hover": {
        color: '#4dc548',
      }
    }}
    >
      {text}
    </Link>
  )
}

export default FooterLink